module.exports = __webpack_public_path__ + "static/img/showroomLeft.86d4b21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroomLeft.png
// module id = gWyk
// module chunks = 2